/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text, VFlow } from 'bold-ui'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'
import { ConsultaSeguimentoPerguntaStatusEnum, ConsultaSeguimentoPerguntaStatusMap } from '../model-consultaSeguimento'

interface ConsultaSeguimentoModalStepperPerguntaStatusProps {
  pergunta: MChatPerguntaEnum
  status: ConsultaSeguimentoPerguntaStatusEnum
}

export function ConsultaSeguimentoModalStepperPerguntaStatus(
  props: Readonly<ConsultaSeguimentoModalStepperPerguntaStatusProps>
) {
  const { pergunta, status } = props

  const { icon, label } = ConsultaSeguimentoPerguntaStatusMap[status]

  return (
    <HFlow hSpacing={0.5} style={styles.root}>
      <div css={styles.iconContainer}>{icon}</div>
      <VFlow vSpacing={0}>
        <Text color={status === ConsultaSeguimentoPerguntaStatusEnum.NAO_DISPONIVEL ? 'secondary' : 'normal'}>
          Pergunta {getMChatPerguntaNumber(pergunta)}
        </Text>
        {label}
      </VFlow>
    </HFlow>
  )
}

const styles = {
  root: css`
    padding: 0.5rem 0;
    grid-auto-columns: 1rem 1fr;
  `,
  iconContainer: css`
    padding-top: 0.125rem;
  `,
}
